import { render } from "./AboutPanel.vue?vue&type=template&id=edd77fdc"
import script from "./AboutPanel.vue?vue&type=script&lang=js"
export * from "./AboutPanel.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__